import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { bhpButtonSx } from "../../../styles/bhpStyles";
import { ByWifiKeyDetails } from "../ByWifiKeyDetails";
import { ByWifiKeyDto } from "../../../dtos/ByWifiKeyDto";
import { DialogTitleClosable } from "../../../components/DialogTitleClosable";

type ByWifiKeyDialogProps = {

    byWifiKeyDto : ByWifiKeyDto;
    dialogOpen : boolean;
    handleOk: ( ) => void;
    wifiKey : string;

};

export const ByWifiKeyDialog : React.FC< ByWifiKeyDialogProps > = ( props : ByWifiKeyDialogProps ) => {

    const { byWifiKeyDto, dialogOpen, handleOk, wifiKey } = props;


    const handleCloseClick = ( ) => handleOk( );

    
    const handleOkClick = ( ) => handleOk( );

    
    return(

        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '520px' } }}
            open={ dialogOpen }>
            <DialogTitleClosable onClose={ handleCloseClick }>
                More Wi-Fi Details
            </DialogTitleClosable>

            <DialogContent dividers>
                
                <ByWifiKeyDetails byWifiKeyDto={ byWifiKeyDto } readOnly={ true } wifiKey={ wifiKey }/>
 
            </DialogContent>
            <DialogActions>
                <Button onClick={ handleOkClick } sx={{ ...bhpButtonSx, width: '100px' }}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>

    );

};